import { useState, useEffect } from 'react';

interface IwindowDimension {
    width: number,
    height: number
}

function getWindowDimensions(): IwindowDimension {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}

export default function useWindowDimensions(): IwindowDimension {
    const [windowDimensions, setWindowDimensions] = useState<IwindowDimension>(getWindowDimensions());

    useEffect(() => {
        function handleResize(): void {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return (): void => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
}